<template>
    <section class="contain">
        <div class="inner" :style="{ minHeight: screenHeight }">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h1 class="panel-title">New Booking</h1>
                </div>
                <div class="panel-body">
                    <h4>
                        To take advantage of our conference rate at the Vida Dubai Marina & Yacht Club
                    </h4>

                    <ul class="mr-l-40">
                        <li class="dot-list">
                            <b> Please <a class="link-style text-underline"
                                    href="https://reservations.travelclick.com/115086?groupID=4170603">click here</a> to
                                book your room </b>. Booking terms and conditions are enclosed in the link.
                        </li>
                        <li class="dot-list">
                            This special rate is applicable for bookings made between <b> March 2<sup>nd</sup> and March
                                8<sup>th</sup> 2024.</b>
                        </li>
                        <li class="dot-list">
                            Due to high demand and limited room availability,<b> room rates and availability are offered on
                                a first-come, first-served basis.</b>
                        </li>
                        <li class="dot-list">
                            For any further inquiries, please email <a class="link-style text-underline"
                                href="mailto:groups@emaar.ae"> groups@emaar.ae</a>.
                        </li>
                        <li class="dot-list">
                            We are delighted to announce <b>that EFG Hermes will be providing shuttle bus services between
                                Vida Dubai Marina and The Address Dubai Marina</b>
                            throughout the duration of the conference for your convenience.
                        </li>
                        <br/>
                        <li class="dot-list">Cancellation Policy
                            <ul class="mr-l-40">
                                <li class="dot-empty">
                                    Modifications & free cancellation is permitted <b>before 3<sup>rd</sup> of February, 2024.</b>
                                </li>
                                <li class="dot-empty">
                                    100% cancellation charges will apply for cancellations made after 3<sup>rd</sup> of February, 2024.
                                </li>
                                <li class="dot-empty">
                                    To cancel your booking, <b> Please <a class="link-style text-underline"
                                            href="https://reservations.travelclick.com/115086?groupID=4170603">click
                                            here</a> to cancel your booking. </b>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: () => ({
        screenHeight: window.innerHeight + "px",
    }),
};
</script>


<style>
.dot-list {
    list-style-type: disc;
}

.dot-empty {
    list-style-type: circle;
}

.mr-l-40 {
    margin-left: 40px;
}

.link-style {
    color: blue;
}</style>